
import { LogLevel } from "@azure/msal-browser";

let signUpSignInAuth;
let forgotPasswordAuth;
let clientId;
let scope;
let authorityDomain;

const hostname = window && window.location && window.location.hostname;

// Config for localhost
if (hostname === 'localhost' || hostname === 'member-user-management-dev.azurewebsites.net' || hostname === 'usermgmt-dev.alas.com') {
    // DEV config
    signUpSignInAuth = 'https://ALASB2CDev.b2clogin.com/ALASB2CDev.onmicrosoft.com/B2C_1A_RD_USERSIGNIN_MUM';
    forgotPasswordAuth = 'https://ALASB2CDev.b2clogin.com/tfp/ALASB2CDev.onmicrosoft.com/B2C_1A_PasswordReset/';
    clientId = '68b71c91-4322-416e-991a-93d0a6f5463d';
    scope = ['https://ALASB2CDev.onmicrosoft.com/f17834c7-8cce-4326-b952-6d49da951217/MUMWebApp.Read'];
    authorityDomain = 'ALASB2CDev.b2clogin.com';
} else if (hostname === 'member-user-management-test.azurewebsites.net' || hostname === 'usermgmt-test.alas.com') {
    // Test config 
    signUpSignInAuth = 'https://ALASB2CDev.b2clogin.com/ALASB2CDev.onmicrosoft.com/B2C_1A_RD_USERSIGNIN_MUM';
    forgotPasswordAuth = 'https://ALASB2CDev.b2clogin.com/tfp/ALASB2CDev.onmicrosoft.com/B2C_1A_PasswordReset/';
    clientId = '68b71c91-4322-416e-991a-93d0a6f5463d';
    scope = ['https://ALASB2CDev.onmicrosoft.com/f17834c7-8cce-4326-b952-6d49da951217/MUMWebApp.Read'];
    authorityDomain = 'ALASB2CDev.b2clogin.com';
} else if (hostname === 'member-user-management-prod.azurewebsites.net' || hostname === 'usermgmt.alas.com') {
    // Prod config 
    signUpSignInAuth = 'https://ALASB2CProd.b2clogin.com/ALASB2CProd.onmicrosoft.com/B2C_1A_RD_USERSIGNIN_MUM';
    forgotPasswordAuth = 'https://ALASB2CProd.b2clogin.com/tfp/ALASB2CProd.onmicrosoft.com/B2C_1A_PasswordReset/';
    clientId = '1525fd0f-4811-43d0-ab03-4570d508e9a6';
    scope = ['https://alasb2cprod.onmicrosoft.com/3e66f476-769b-4d03-99f4-ed7c0861d228/MUMWebApp.Read'];
    authorityDomain = 'ALASB2CProd.b2clogin.com';
} else {
    throw 'Environment not implemented: ' + hostname;
}

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1A_RD_USERSIGNIN_MUM',
        forgotPassword: 'B2C_1A_PasswordReset',
    },
    authorities: {
        signUpSignIn: {
            authority: signUpSignInAuth,
        },
        forgotPassword: {
            authority: forgotPasswordAuth,
        }
    },
    authorityDomain: authorityDomain,
};


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: clientId, // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        scope: scope
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    }
};
